/**
 * Normalizes currency-like values to a number.
 * - Returns undefined for nullish values
 * - Parses strings by stripping currency symbols/commas while preserving sign
 * - Passes through numbers unchanged
 */
export const normalizeCurrencyValue = (value?: number | string | null) => {
    if (value === undefined || value === null) {
        return undefined;
    }

    if (typeof value === 'number') {
        return value;
    }

    const cleaned = value.replace(/[^0-9.-]/g, '');
    if (!cleaned.trim()) {
        return undefined;
    }

    const parsed = Number(cleaned);
    return Number.isNaN(parsed) ? undefined : parsed;
};
